import OAuthAuthPage from "./OAuthAuthPage"

const ShopifyAuthPage = (props) => {
  return <OAuthAuthPage {...props} provider="shopify" />
}

export default ShopifyAuthPage
